<div class="db-hosting-resource-usage">
  <ds-mobile-page-title></ds-mobile-page-title>

  <db-ai-builder-demo-banner *ngIf="demoUser" [title]="'Resource usage'" [features]="features" [class]="'with_margins'">
  </db-ai-builder-demo-banner>

  <div class="db-hosting-resource-usage-body-wrap" [ngClass]="{'disabled-with-overlay': demoUser}">
    <div class="db-resource-storage__block">
      <div class="db-block-header">{{'text_hosting.resource-usage' | dbText}}</div>
      <div class="hosting-storage-canvas-wrap">
        <div class="db-resource-storage__hosting-block">
          <div class="db-resource-storage__hosting-block-visits">
            <p [innerHTML]="'text_HostingTotalVisits' | dbText: {visits: allVisitorsByWebsite}"></p>
            <div class="db-hosting-resource-usage__storage">
              <strong>{{'text_includedDates' | dbText}}</strong>
              <span class="db-visitors-date sl-hosting-resource-dates">{{allVisitorsByWebsiteStartDate + " - " + allVisitorsByWebsiteEndDate}}</span>
            </div>
          </div>
          <div  class="db-resource-storage__hosting-block-storage">
            <div><span>{{'text_ssd-storage' | dbText}}</span></div>
            <div>
              <div>
                <p [innerHTML]="'text_HostingDatabaseStorage' | dbText: {storage: usedHostingDbStorageByWebsite | size}"></p>
                <p [innerHTML]="'text_HostingFilesStorage' | dbText: {storage: usedHostingFileStorageByWebsite | size}"></p>
              </div>
              <div class="total_storage"><p [innerHTML]="'text_HostingTotalStorageByWebsite' | dbText: {storage: usedHostingDbStorageByWebsite + usedHostingFileStorageByWebsite | size}"></p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="db-visitors_block">
      <div class="db-block-header">{{'text_hosting.visit-analytics' | dbText}}</div>
      <div class="data-filter-block">
        <div class="db-all-data-block">
          <div><span>{{'text_visitorsChart' | dbText}} </span><span class="sl-hosting-visits-chart-count">{{allVisitors}}</span></div>
          <div *ngIf="allDates.length" class="sl-hosting-visits-chart-date">{{allDates[0] | dbDate : 'MMM dd'}} - {{allDates[allDates.length-1] | dbDate : 'MMM dd'}}</div>
        </div>
        <div class="db-filter-block">
          <db-fc-dropdown-select class="select-component" [formControl]="filterDate" [value]="filterDate?.value" [options]="filterDateOptions"></db-fc-dropdown-select>

        </div>
      </div>
      <div id="canvas-holder" *ngIf="lineChartData">
        <div class="line-wrap">
          <div class="line" [ngStyle]="{'width': 'calc(100%/' + (lineChartLabels.length-2) + ')', 'height': 'calc(100% - ' + lineHeight + ')'}" *ngFor="let lines of lineChartLabels | limit : {'startFrom': 1,'maxItems': lineChartLabels.length-1}"></div>
        </div>
        <div class="canvas-wrap" [ngStyle]="{'margin': canvasWrapMargin}">
          <canvas *ngIf="lineChartLabels && lineChartLabels.length" id="chart"  baseChart
                  [datasets]="lineChartData"
                  [labels]="lineChartLabels"
                  [options]="lineChartOptions"
                  [legend]="lineChartLegend"
                  [type]="lineChartType"
                  (chartHover)="chartHovered($event)"
                  (chartClick)="chartClicked($event)"></canvas>
          <db-loading-screen [pageBlocker]="true" [hidden]="!loading"></db-loading-screen>
        </div>

      </div>
    </div>

  </div>
</div>
